module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"empty":"Видеозвонок завершен, но запись не сохранилась из-за отсутствия видео и аудио материалов"}}')
  delete Component.options._Ctor
}
